import { render, staticRenderFns } from "./CaseLoadRecordsIndex.vue?vue&type=template&id=1095eea9&scoped=true&"
import script from "./CaseLoadRecordsIndex.vue?vue&type=script&lang=js&"
export * from "./CaseLoadRecordsIndex.vue?vue&type=script&lang=js&"
import style0 from "./CaseLoadRecordsIndex.vue?vue&type=style&index=0&id=1095eea9&prod&scoped=true&lang=css&"
import style1 from "./CaseLoadRecordsIndex.vue?vue&type=style&index=1&id=1095eea9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1095eea9",
  null
  
)

export default component.exports